import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetGalleries =
  ({ callback, gallery_type, media_post_id, section_id }) =>
  async (dispatch, getState) => {
    try {
      const data = {};
      if (gallery_type) data.gallery_type = gallery_type;
      if (media_post_id) data.media_post_id = media_post_id;
      if (section_id) data.section_id = section_id;

      const response = await PostFunction({
        data,
        Route: gallery_type ? UrlApi.galleries.get + "?gallery_type=" + gallery_type : UrlApi.galleries.get,
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageGalleries =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }
      
      if (values.title) bodyFormData.append("title", values.title.trim());
      if (values.description) bodyFormData.append("description", values.description.trim());
      if (values.gallery_type) bodyFormData.append("gallery_type", values.gallery_type);
      if (values.media_post_id) bodyFormData.append("media_post_id", values.media_post_id);
      if (values.section_id) bodyFormData.append("section_id", values.section_id);
      if (values.display_order !== undefined) bodyFormData.append("display_order", values.display_order);
      if (values.is_active !== undefined) bodyFormData.append("is_active", Boolean(values.is_active));
      
      // Handle image upload - support multiple files
      if (values.image) {
        if (Array.isArray(values.image) || values.image instanceof FileList) {
          // Multiple files
          const files = Array.isArray(values.image) ? values.image : Array.from(values.image);
          files.forEach((file, index) => {
            if (file instanceof File) {
              bodyFormData.append(`images[${index}]`, file);
            }
          });
        } else if (values.image instanceof File) {
          // Single file - new upload
          bodyFormData.append("image", values.image);
        } else if (typeof values.image === "string" && values.image.trim() !== "") {
          // Existing image URL - preserve it when editing
          bodyFormData.append("image_url", values.image);
        }
      } else if (editMode && values.image_url) {
        // When editing and no new image selected, preserve existing image
        bodyFormData.append("image_url", values.image_url);
      }

      const route = editMode ? UrlApi.galleries.edit : UrlApi.galleries.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditGalleries =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      // Convert boolean fields to proper boolean values
      if (nameFailed === "is_active") {
        formData.append(nameFailed, Boolean(dataFailed));
      } else {
        formData.append(nameFailed, dataFailed);
      }
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.galleries.edit,
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "image",
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteGalleries =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.galleries.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

